import api from './axios';

export const getQuotesApi   = (params) => api.get('/quotes', { params });
export const getQuoteApi    = (id, config = {}) => api.get(`/quotes/${id}`, config);
export const createQuoteApi = (data)   => api.post('/quotes', data);
export const updateQuoteApi = (id, data) => api.put(`/quotes/${id}`, data);
export const updateQuoteStatusApi = (id, status) => api.patch(`/quotes/${id}/status`, { status });
export const deleteQuoteApi = (id)     => api.delete(`/quotes/${id}`);
export const getQuotePdfLinkApi = (id) => api.get(`/quotes/${id}/pdf-link`);
export const sendQuoteOnWhatsAppApi = (id) => api.post(`/quotes/${id}/send-whatsapp`);
export const uploadQuoteWhatsAppPdfApi = (id, data) =>
  api.post(`/quotes/${id}/whatsapp-pdf`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const uploadAgreementPdfApi = (id, data) =>
  api.post(`/quotes/${id}/agreement-pdf`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteQuoteFileApi = (id, filename) =>
  api.delete(`/quotes/${id}/files/${encodeURIComponent(filename)}`);
